(function ($, Cobalt, undefined) {
    Cobalt.UserManagement = {
        initialize: function () {

            $(".ban-description").hide();
            $("#field-ban-type").change(function () {
                $(".ban-description").hide();
                var banID = $(this).val();
                $("#ban-desc-" + banID).show();
            });


            var advancedSearchForm = $("div#user-advanced-search-form");
            var searchButton = $("input[type=\"submit\"]#user-search-form-submit");
            var advancedSearchButton = $("input[type=\"button\"]#user-search-advanced-button");

            var simpleSearchBy = $("select#field-searchBy");
            var simpleSearchMethod = $("select#field-searchMethod");


            if (simpleSearchBy.val() == "4" || simpleSearchBy.val() == "2") {
                simpleSearchMethod.val("2");
                simpleSearchMethod.attr("disabled", "disabled");
            }
            simpleSearchBy.change(function () {
                if (simpleSearchBy.val() == "4" || simpleSearchBy.val() == "2") {
                    simpleSearchMethod.val("2");
                    simpleSearchMethod.attr("disabled", "disabled");
                }
                else {
                    simpleSearchMethod.removeAttr("disabled");
                }
            });

            $("#filter-search-by").change(function () {
                Cobalt.UserManagement.saveFilterConditions(this, "Preferences.CPUserSearch.ConstraintBy");
            });

            $("#filter-search-method").change(function () {
                Cobalt.UserManagement.saveFilterConditions(this, "Preferences.CPUserSearch.ConstraintMethod");
            });

            var sortSelect = $("select#field-sort");
            var sortOrderSelect = $("select#advanced-search-sort-order");
            Cobalt.UserManagement.bindSortOrderChangeEvent(sortOrderSelect, sortSelect);

            if (advancedSearchForm.length > 0) {
                if ($("#user-search-is-advanced").val() == "true") {
                    advancedSearchButton.val(L.Global.Common.SimpleSearch());
                }
                else {
                    $("div#user-advanced-search-form").remove();

                }
            }

            advancedSearchButton.click(function () {
                if ($(this).val() == L.Global.Common.SimpleSearch()) {
                    $("div#user-advanced-search-form").remove();
                    $(this).val(L.Global.Common.AdvancedSearch());
                }
                else {
                    searchButton.before(advancedSearchForm);
                    Cobalt.UserManagement.bindSortOrderChangeEvent(sortOrderSelect, sortSelect);
                    $('input[type=text].date').datepicker({ changeMonth: true, changeYear: true });
                    $(this).val(L.Global.Common.SimpleSearch());
                }
            });

            $(".j-user-ip-history").on("click", ".j-user-ip-whitelisted", function () {
                var checkbox = $(this);
                var isChecked = checkbox.is(":checked");
                var userSlug = checkbox.attr("data-user-slug");
                var ipAddressID = checkbox.val();

                if (!confirm("Are you sure you want to " + (!isChecked ? "remove this IP address from the white list?" : "add this IP address to the white list?"))) {
                    return false;
                }

                $.ajax(
                {
                    type: "POST",
                    url: "/cp/users/" + userSlug + "/whitelist-ip/" + ipAddressID,
                    success: function () {
                        location.reload();
                    }
                });
            });

            $(".j-user-ip-history").on("click", ".j-user-ip-whitelisted-by-subnet", function () {
                var checkbox = $(this);
                var isChecked = checkbox.is(":checked");
                var userSlug = checkbox.attr("data-user-slug");
                var ipAddressID = checkbox.val();

                if (!confirm("Are you sure you want to " + (!isChecked ? "from the white list?" : "whitelist this IP by subnet? Be aware of the risks."))) {
                    return false;
                }

                $.ajax(
                    {
                        type: "POST",
                        url: "/cp/users/" + userSlug + "/whitelist-ip-by-subnet/" + ipAddressID,
                        success: function() {
                            location.reload();
                        }
                    });
            });
        },
        saveFilterConditions: function(dropdownElement, cookieName) {
            $.cookie(cookieName, $(dropdownElement).val(), { expires: 365, domain: '.' + Cobalt.Utils.getCurrentDomain(), path: '/', secure: true });
        },
        bindSortOrderChangeEvent: function (select, sortSelect) {
            $(select).change(function () {
                if ($(this).val() == L.Global.Common.Ascending()) {
                    sortSelect.children("option").each(function () {
                        if ($(this).val().startsWith("-")) {
                            $(this).val($(this).val().slice(1, $(this).val().length));
                        }
                    });
                }
                else if ($(this).val() == L.Global.Common.Descending()) {
                    sortSelect.children("option").each(function () {
                        var newVal = "-" + $(this).val();
                        $(this).val(newVal);
                    });
                }
            });
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.UserManagement.js